<template>
  <article class="content-container home">
    <h2>{{title}}</h2>
    <div class="slide-container">
      <v-touch tag="ul" class="slides swipe" v-on:swipeleft="nextSlide" v-on:swiperight="prevSlide">
        <li v-for="(slide,index) in slides" v-on:click="loadLink(slide)" :class="{active:slide.active}">
          <vue-picture :imgset="slide.image" :sizes="fixedSizes" defaultSize="scale_crop_1024_461"></vue-picture>
        </li>
      </v-touch>
      <div class="arrow prev icon-triangle-prev" v-on:click="prevSlide()"></div>
      <div class="arrow next icon-triangle-next" v-on:click="nextSlide()"></div>
    <nav>
      <ol class="horizontal circles plain">
        <template v-for="(slide,index) in slides">
          <li v-on:click="setActive(index)" :class="{active:slide.active}">{{slide.index+1}}</li>
        </template>
      </ol>
    </nav>
    </div>    
  </article>
</template>

<script>

import VuePicture from './VuePicture.vue'
import ImageManager from './ImageManager.vue'

export default {
  name: 'home',
  mixins: [ImageManager],
  data: function () {
    return {
      title: 'Welcome',
      content: {},
      slides: [],
      numSlides: 0,
      fullSizes: {},
      fixedSizes: {},
      notLoaded: true,
      timer: null,
      speed: 6000,
    }
  },
  beforeRouteEnter: function (to,from,next) {
    next(function(vm) {
      vm.initPage()
    })
  },
  created: function () {
    var comp = this
    this.timer = setInterval(function () {
      comp.nextSlide(true)
    }, this.speed)
    this.$parent.$on('nav-screen', function(val) {
      if (val == 'prev') {
        comp.nextSlide()
        
      } else {
        comp.nextSlide()
      }
    })
  },
  methods: {
    initPage: function () {
      var comp = this
      this.$parent.scrollTo(0,500)
      if (this.$parent.infoLoaded) {
        this.fullSizes = this.$parent.fullSizes
        this.fixedSizes = this.$parent.fixedSizes
        if (this.slides.length < 1) {
          this.loadHome();
        }
      } else {
          setInterval(function () {
            if (comp.$parent.infoLoaded && comp.notLoaded) {
              comp.fullSizes = comp.$parent.fullSizes
              comp.loadHome();
            }
          }, 200)
      }
      setTimeout(function(){
        comp.$parent.scrollTo(0,250)
      }, 500)
    },
    loadHome: function () {
      var comp = this
      this.notLoaded = false

      this.slides = []
      this.$parent.loadData('home', function(data) {
        comp.$parent.currId = data.nid
        comp.title = data.title
        comp.content.body = data.body
        if (data.sections) {
          var numSlides = data.sections.length
          var index = 0
          for (var i =0; i < numSlides; i++) {
            var item = data.sections[i]
            var slide = {}
            if (item.image) {
              slide.image = item.image
              if (item.link) {
                slide.link = item.link
              }
              slide.index = index
              slide.active = index === 0
              comp.filterImgSizes(slide.image.sizes)
              comp.slides.push(slide)
              comp.$parent.preloadImg(slide.image.sizes)
              index++
            }
          }
          comp.numSlides = comp.slides.length
          comp.$parent.removeContainerClass('loading')
        }
      })
    },
    prevSlide: function() {
      this.setActive('prev')
    },
    nextSlide: function(auto) {
      this.setActive('next',auto)
    },
    setActive: function(index,auto) {
      var currIndex = _.findIndex(this.slides, function (slide) { return slide.active })
      switch (index) {
        case 'next':
          if (currIndex < (this.numSlides - 1)) {
            index = currIndex + 1
          } else {
            index = 0
          }
          break;
        case 'prev':
          if (currIndex > 0) {
            index = currIndex - 1
          } else {
            index = this.numSlides - 1
          }
          break;
      }
      if (currIndex !== index && this.numSlides > index) {
        this.slides[index].active = true
        if (currIndex >= 0 && currIndex < this.numSlides) {
          this.slides[currIndex].active = false
        }
      }
      if (auto !== true) {
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    },
    loadLink: function(slide) {
      if (slide.link) {
        if (slide.link.url) {
          this.$router.push(slide.link.url)
        }
      }
    }
  },
  components: {
    VuePicture
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?39f04901